export * from './ProductCardV2ProductDetail';
